import { Col } from "react-bootstrap";
import { notShownInheritedAuctionsAlertLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../../../contexts/CookiesContext";

export default function NotShownInheritedAuctionsAlert({
    clusterInheritedAuctionsAndNotShown,
    closedAlert,
    setClosedAlert,
}) {
    const { getLanguageAbbr } = useCookiesContext();
    const languageAbbr = getLanguageAbbr();
    const { title, message } = notShownInheritedAuctionsAlertLabels[languageAbbr];
    return (
        clusterInheritedAuctionsAndNotShown.length > 0 ? (
            !closedAlert ? (
              <Col md="12">
                <div className="fade alert alert-dismissible warning-system-alert show mb-0">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close alert"
                    onClick={() => setClosedAlert(true)}
                  ></button>
                  <div className="banner">
                    <h3 className="banner-title">
                      {title(clusterInheritedAuctionsAndNotShown.length)}
                    </h3>
                    <p className="banner-text">
                      {message}
                    </p>
                  </div>
                </div>
              </Col>
            ) : (
              <></>
            )
          ) : (
            <></>
          )
    )
}